<!--<div class="card" [ngStyle]="{'background-color': Item.isActive ? '#567d2b': '#00b353'}">-->
<div class="card" [ngStyle]="{'background-color': Item.isActive ? '#516226': '#89903f'}">
    <div class="card-header">
      <img src="images/carrot.png" class="active" [ngStyle]="{'display': Item.isActive ? 'block': 'none'}" />
      <span *ngIf="Item.links && Item.links.length > 0 ; else Propsearch">
        <a class="card-link" data-toggle="collapse" (click)="expandMenu(Item.name)">
          {{ Item.displayName }}
        </a>
      </span>
      <ng-template #Propsearch>
        <a [routerLink]="Item.path" class="card-link" data-toggle="collapse" (click)="expandMenu(Item.name)">
          {{ Item.displayName }}
        </a>
      </ng-template>

    </div>
    <span *ngIf="Item.links && Item.links.length > 0">
      <div [ngClass]="{ 'collapse': true, 'show': Item.isActive}" data-parent="#accordion">
        <div class="card-body" *ngIf="Item.name!=='UnindexedRecords' ; else UnIndexMenu">
          <span *ngFor="let link of Item.links">
            <a [routerLink]="link.path" class="nav-link sub-menu" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"> {{link.displayName}} </a>
          </span>
        </div>
        <ng-template #UnIndexMenu>
          <span *ngFor="let link of Item.links">
            <a [routerLink]='[link.path, link.displayName]' class="nav-link sub-menu" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"> {{link.displayName}} </a>
          </span>
        </ng-template>
      </div>
    </span>
</div>


